module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_59.59a1fa5d.png";